import transformToCamelCase from '../../shared/transformers/toCamelCaseTransformer';

export default function transformReleaseActions(actions) {
  if (!actions || !actions.length) return {};

  const actionsObj = actions.reduce((obj, action) => {
    obj[action] = true;
    return obj;
  }, {});

  return transformToCamelCase(actionsObj);
}
